import type { User } from "@supabase/supabase-js";
import { getSupabaseClient } from "./supabase";

export async function getCurrentUser(): Promise<User | null> {
  try {
    const { data: { session } } = await getSupabaseClient().auth.getSession();
    return session?.user ?? null;
  } catch (error) {
    console.error("Current session could not be read", error);
    return null;
  }
}

export async function getAuthToken(): Promise<string | null> {
  try {
    const { data: { session } } = await getSupabaseClient().auth.getSession();
    return session?.access_token ?? null;
  } catch (error) {
    console.error("Auth token could not be read", error);
    return null;
  }
}

export async function signInWithPassword(
  email: string,
  password: string,
): Promise<void> {
  const { error } = await getSupabaseClient().auth.signInWithPassword({
    email: email.trim().toLowerCase(),
    password,
  });
  if (error) throw error;
}

export async function requestPasswordReset(email: string): Promise<void> {
  const { error } = await getSupabaseClient().auth.resetPasswordForEmail(
    email.trim().toLowerCase(),
  );
  if (error) throw error;
}

export async function updatePassword(password: string): Promise<void> {
  const { error } = await getSupabaseClient().auth.updateUser({ password });
  if (error) throw error;
}

export async function signOutEverywhere(): Promise<void> {
  const { error } = await getSupabaseClient().auth.signOut({ scope: "global" });
  if (error) throw error;
}

export async function signOut(): Promise<void> {
  const { error } = await getSupabaseClient().auth.signOut();
  if (error) throw error;
}
